import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../service/api";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { DataTable, DataTableStringComparison } from "../../../components/DataTable";
import { AdminPage } from "../AdminPage";
import { SplitScreenDiv } from "../../../components/SplitScreenDiv";
import { PermissionEdit } from "./PermissionEdit2";

export const PermissionsPage = ({canAdd, canEdit, canDelete}) => {
    const [selectedId, setSelectedId] = useState<number|null>(null);
    const [data, setData] = useState([]);
    const [maximal, setMaximal] = useState(null);
    const [minimal, setMinimal] = useState(null);
    const { t } = useTranslation();

    const fetchPermissions = useCallback(async() => {
        try {
            const d = await API.GET('/api/rights');
            setMaximal(d.maximal);
            setMinimal(d.minimal);
            setData(d.rights.filter(r => r.id !== 0));
        }catch(err){

        }
    }, [selectedId]);

    useEffect(() => {
        fetchPermissions();
    }, [])

    const Table = useMemo(() => (
        <DataTable<any>
            data={data}
            height={500}
            onRowSelected={p => setSelectedId(p.id)}
            columns={[
                {headerName: t('name'), flex: 1, valueGetter: ({data}) => ({Name: data.Name, private: data.private}), cellRenderer: ({value}) => (
                    <span style={{overflow: 'hidden', textOverflow: 'clip', whiteSpace: 'nowrap'}}>
                        <MDBIcon icon="briefcase" color="primary" className="me-1"/>
                        {value.Name}
                        {value.private &&
                            <span className="badge badge-info ms-1">{t('default')}</span>
                        }
                    </span>
                ), comparator: (row1, row2) => DataTableStringComparison(row1.data.Name, row2.data.Name)}
            ]}
        />
    ), [data]);

    const PermissionEditScreen = useMemo(() => selectedId == null ? null : (
        <PermissionEdit
            rightsId={selectedId}
            maximal={maximal}
            minimal={minimal}
            canEdit={canEdit}
            canDelete={canDelete}
            onAdd={() => fetchPermissions()}
            onEdit={() => fetchPermissions()}
            onDelete={() => setSelectedId(null)}
        />
    ), [selectedId, maximal, minimal]);

    if (!maximal || !minimal) return null;

    return (
        <AdminPage
            title={t('permissions')}
            header={!canAdd ? null : (
                <MDBBtn color="link" onClick={() => setSelectedId(-1)}>
                    <MDBIcon icon="plus-circle" className="me-1"/>
                    {t('add_permissions')}
                </MDBBtn>
            )}
        >
            <SplitScreenDiv
                ratio={40}
                left={Table}
                right={PermissionEditScreen}
            />
        </AdminPage>
    )
}